<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">System roles</div>
            <fieldset class="border p-3">
              
              <div class="row">
                <div class="col-md-12">
                  <fieldset class="border p-3">
                    <label
                      for="fullnames"
                      style="font-size: 13px; font-weight: bold"
                      >Fullnames:</label
                    >
                    <span style="font-size: 13px">{{ User.fullname }}</span>
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="border p-4">
                        <legend>
                          <small style="font-size: 12px">roles</small>
                        </legend>
                        <div class="userrolesLoader">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <i
                            class="fa fa-spinner fa-spin"
                            style="font-size: 24px; color: blue"
                          ></i>
                          loading roles...
                        </div>
                        <div class="row">
                          <ul
                            v-for="newrole in systemRoles"
                            v-bind:key="newrole.id"
                          >
                            <b-col md="12" class="form-filters">
                              <input
                                type="hidden"
                                class="checkbox checkbox-success userid"
                                :value="User.id"
                              />
                              <input
                                type="checkbox"
                                :value="newrole.id"
                                :data-newrole="newrole.id"
                                :checked="userRoles.includes(newrole.id)"
                                @change="Storeroles(newrole.id)"
                              />
                              <label for>&nbsp;{{ newrole.role_name }}</label>
                            </b-col>
                          </ul>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="border p-4">
                        <legend>
                          <small style="font-size: 12px">modules</small>
                        </legend>
                        <!-- {{
                    JSON.stringify(modules.find(function(modules){
                         return modules.id === moduleId
                    }))                    
                }} -->
                        <div class="rolemodulesLoader">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <i
                            class="fa fa-spinner fa-spin"
                            style="font-size: 24px; color: green"
                          ></i>
                          loading modules...
                        </div>
                        <div class="row">
                          <ul
                            v-for="rolemodule in modules"
                            v-bind:key="rolemodule.id"
                          >
                            <b-col md="12" class="form-filters">
                              <input
                                type="hidden"
                                class="userid"
                                :value="User.id"
                              />
                              <input
                                type="checkbox"
                                :value="rolemodule.id"
                                :data-newrole="rolemodule.id"
                                :checked="
                                  userRoleModules.includes(rolemodule.id)
                                "
                                @change="Storerolemodules(rolemodule.id)"
                              />
                              <label for
                                >&nbsp;{{ rolemodule.module_name }}</label
                              >
                            </b-col>
                          </ul>
                        </div>
                      </fieldset>
                      <hr />

                      <button
                        class="btn btn-info btn-sm asignRoleModules"
                        @click="asignUserRoleModules()"
                      >
                        <i class="fa fa-plus"></i> Assign roles
                      </button>
                      <button
                        type="button"
                        class="btn btn-info btn-sm asigninUserRoleModulesLoader"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <i
                          class="fa fa-spinner fa-spin"
                          style="font-size: 24px"
                        ></i>
                        please wait...
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <fieldset class="border p-4">
                    <legend>
                      <small style="font-size: 12px">permissions</small>
                    </legend>
                    <div class="modulespermissionLoader">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px; color: green"
                      ></i>
                      loading ...
                    </div>

                    <ul
                      v-for="permission in systemPermissions"
                      v-bind:key="permission.id"
                    >
                      <b-col md="12" class="form-filters">
                        <input type="hidden" class="userid" :value="User.id" />
                        <input
                          type="checkbox"
                          :value="permission.id"
                          :data-modpermission="permission.id"
                          :checked="
                            rolemModulePermissions.includes(permission.id)
                          "
                          @change="StorerolemodulesPermissions(permission.id)"
                        />
                        <label for
                          >&nbsp;{{ permission.permission_name }}</label
                        >
                      </b-col>
                    </ul>
                    <hr />
                    <button
                      type="button"
                      class="btn btn-info btn-sm asignModuleLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                    <button
                      class="btn btn-primary btn-sm asignPermissionsBtns"
                      @click="asignModulePermissions()"
                    >
                      <i class="fa fa-key"></i> Assign permmision
                    </button>
                  </fieldset>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";

export default {
  created() {
    this.loadRoles();
    this.loadModules();
    this.loadPermissions();
    if (this.$store.getters.User.length === 0) {
      router.push("/manageusers");
    }
  },
  computed: {
    ...mapGetters([
      "systemRoles",
      "modules",
      "systemPermissions",
      "User",
      "userRoles",
      "userRoleModules",
      "rolemModulePermissions",
      "moduleId",
    ]),
  },
  methods: {
    ...mapActions([
      "loadRoles",
      "loadModules",
      "loadPermissions",
      "Storeroles",
      "Storerolemodules",
      "asignUserRoleModules",
      "asignModulePermissions",
      "StorerolemodulesPermissions",
    ]),
  },
};
</script>
<style scoped>
.asigninUserRoleModulesLoader {
  display: none;
}
.asignModuleLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/userroles/userrole.vue